// Below is for GABQ
export const ProductsAndModalities = {
  memberNumber: '10108246',
  members: [
    {
      personCode: '2922',
      firstName: 'Elaine',
      lastName: 'Benes',
      products: [
        {
          productCode: 'AMBULANCE',
          startDate: '2023-01-01',
        },
        {
          productCode: 'PREMIER_EXTRAS',
          startDate: '2023-01-01',
        },
      ],
    },
    {
      personCode: '2408',
      firstName: 'Elaine2',
      lastName: 'Benes',
      products: [
        {
          productCode: 'AMBULANCE',
          startDate: '2023-01-01',
        },
        {
          productCode: 'PREMIER_EXTRAS',
          startDate: '2023-01-01',
        },
      ],
    },
    {
      personCode: 'Member-100200000000',
      firstName: 'David',
      lastName: 'Puddy',
      products: [
        {
          productCode: 'AMBULANCE',
          startDate: '2023-01-01',
        },
      ],
    },
    {
      personCode: 'Member-1006',
      firstName: 'Seven',
      lastName: 'Puddy',
      products: [
        {
          productCode: 'PREMIER_EXTRAS',
          startDate: '2023-01-01',
        },
      ],
    },
  ],
  products: [
    {
      productCode: 'AMBULANCE',
      productId: '2107',
      productType: 'AMBULANCE',
      modalities: [
        {
          modalityCode: 'AMBULANCE',
          modalityName: 'Ambulance Modality',
        },
      ],
    },
    {
      productCode: 'PREMIER_EXTRAS',
      productId: '2005',
      productType: 'EXTRAS',
      modalities: [
        {
          modalityCode: 'WIG',
          modalityName: 'Wig Modality',
        },
        {
          modalityCode: 'ORTHO',
          modalityName: 'Orthodontics Modality',
        },
        {
          modalityCode: 'OSTEO',
          modalityName: 'Osteotherapy Modality',
        },
        {
          modalityCode: 'PHARM',
          modalityName: 'Pharmacy Modality',
        },
        {
          modalityCode: 'EPIPEN',
          modalityName: 'EpiPen Modality',
        },
        {
          modalityCode: 'OPTICAL',
          modalityName: 'Optical Modality',
        },
        {
          modalityCode: 'PODIATRY',
          modalityName: 'Podiatry Modality',
        },
        {
          modalityCode: 'AUDIOLOGY',
          modalityName: 'Audiology Modality',
        },
        {
          modalityCode: 'DIETETICS',
          modalityName: 'Dietetics Modality',
        },
        {
          modalityCode: 'HEAR_AIDS',
          modalityName: 'Hearing Aids Modality',
        },
        {
          modalityCode: 'GEN_DENTAL',
          modalityName: 'General and Preventative Dental Modality',
        },
        {
          modalityCode: 'MYOTHERAPY',
          modalityName: 'Myotherapy Modality',
        },
        {
          modalityCode: 'ORTH_SHOES',
          modalityName: 'Orthopaedic Shoes Modality',
        },
        {
          modalityCode: 'PSYCHOLOGY',
          modalityName: 'Psychology Modality',
        },
        {
          modalityCode: 'TRAVEL_VAC',
          modalityName: 'Travel Vaccination Modality',
        },
        {
          modalityCode: 'ACUPUNCTURE',
          modalityName: 'Acupuncture Modality',
        },
        {
          modalityCode: 'EYE_THERAPY',
          modalityName: 'Eye Therapy Modality',
        },
        {
          modalityCode: 'REM_MASSAGE',
          modalityName: 'Remedial Massage Modality',
        },
        {
          modalityCode: 'CHIROPRACTIC',
          modalityName: 'Chiropractic Modality ',
        },
        {
          modalityCode: 'GROUP_PHYSIO',
          modalityName: 'Group Physiotherapy Modality',
        },
        {
          modalityCode: 'MAJOR_DENTAL',
          modalityName: 'Major Dental Modality',
        },
        {
          modalityCode: 'TENS_MACHINE',
          modalityName: 'TENS Machine Modality',
        },
        {
          modalityCode: 'COMP_GARMENTS',
          modalityName: 'Compression Garments Modality',
        },
        {
          modalityCode: 'MOBILITY_AIDS',
          modalityName: 'Mobility Aids Modality',
        },
        {
          modalityCode: 'PHYSIOTHERAPY',
          modalityName: 'Physiotherapy Modality',
        },
        {
          modalityCode: 'ANTE_POSTNATAL',
          modalityName: 'Ante & Postnatal Modality',
        },
        {
          modalityCode: 'ARTIFICIAL_EYE',
          modalityName: 'Artificial Eye Modality',
        },
        {
          modalityCode: 'EXE_PHYSIOLOGY',
          modalityName: 'Exercise Physiology Modality',
        },
        {
          modalityCode: 'FOOT_ORTHOTICS',
          modalityName: 'Foot Orthotics Modality',
        },
        {
          modalityCode: 'NEB_AND_SPACER',
          modalityName: 'Nebuliser and Spacer Modality',
        },
        {
          modalityCode: 'RENTAL_OF_APPS',
          modalityName: 'Rental of Appliances Modality',
        },
        {
          modalityCode: 'SPEECH_THERAPY',
          modalityName: 'Speech Therapy Modality',
        },
        {
          modalityCode: 'APP_MAINTENANCE',
          modalityName: 'Appliance Maintenance Modality',
        },
        {
          modalityCode: 'GROUP_EX_PHYSIO',
          modalityName: 'Group Exercise Physiology Modality',
        },
        {
          modalityCode: 'SCHOOL_ACCIDENTS',
          modalityName: 'School Accidents Modality',
        },
        {
          modalityCode: 'NON_COSMETIC_PROS',
          modalityName: 'Non Cosmetic Prostheses Modality',
        },
        {
          modalityCode: 'BLOOD_GLU_MONITIOR',
          modalityName: 'Blood Glucose Monitor',
        },
        {
          modalityCode: 'SPLINTS_AND_BRACES',
          modalityName: 'Splints and Braces Modality',
        },
        {
          modalityCode: 'TESTS_AND_PROGRAMS',
          modalityName: 'Tests and Programs Modality',
        },
        {
          modalityCode: 'BLOOD_PRES_MONITIOR',
          modalityName: 'Blood Pressure Monitor',
        },
        {
          modalityCode: 'EXTERNAL_BREAST_PROS',
          modalityName: 'External Breast Prostheses Modality',
        },
        {
          modalityCode: 'OCCUPATIONAL_THERAPY',
          modalityName: 'Occupational Therapy Modality',
        },
        {
          modalityCode: 'LASER_REF_EYE_SURGERY',
          modalityName: 'Laser Refractive Eye Surgery Modality',
        },
        {
          modalityCode: 'PAP_MACH_FOR_SLEEP_AP',
          modalityName: 'PAP Machines for Sleep Aponea Modality',
        },
        {
          modalityCode: 'JOINT_FLUID_REP_INJECT',
          modalityName: 'Joint Fluid Replacement Injection Modality',
        },
        {
          modalityCode: 'NON_SIGHT_COR_IRLEN_LENSE',
          modalityName: 'Non-Sight Correcting Irlen Modality',
        },
      ],
    },
  ],
};

export const MultiStepFormReferenceData = {
  benefitQuoteInformationText: {
    informationText:
      '<p>Simply tell us who is receiving the treatment (services), the claim type, what the services are, the provider and fee you&rsquo;re being charged. We&rsquo;ll do the rest to calculate your benefit quote.</p>\r\n',
  },
  memberReceivingServicesHelpText: {
    informationText:
      '<p>Based on your policy permissions, you can get a quote for these members. Find out more about&nbsp;<a href="/error" target="_blank">policy permissions</a>.</p>\r\n',
  },
  annualBenefitLimitHelpText: {
    informationText:
      '<p>This limit is your overall flexi-limit.</p>\r\n\r\n<p><a href="/portal/Support/Help-HQ/2019/November/Extra-flexibility-with-flexi-limits" target="_blank">Read more about flexi-limits here.</a></p>\r\n',
  },
  searchProviderHelpText: {
    informationText:
      '<p id="cache53">Search tip: If you know the provider number, this is the quickest way to search.</p>\r\n\r\n<p id="cache55">If you don&rsquo;t, enter their surname, suburb or state.</p>\r\n',
  },
  dateOfServiceHelpText: {
    informationText: '<p>Tip: Enter the appointment date or approximate date.</p>\r\n',
  },
  toothNumberOptions: [
    {
      display: 'Anterior Adult Upper Right',
      returnValue: '11',
    },
    {
      display: 'Anterior Adult Upper Right',
      returnValue: '12',
    },
    {
      display: 'Anterior Adult Upper Right',
      returnValue: '13',
    },
    {
      display: 'Posterior Adult Upper Right',
      returnValue: '14',
    },
    {
      display: 'Posterior Adult Upper Right',
      returnValue: '15',
    },
    {
      display: 'Posterior Adult Upper Right',
      returnValue: '16',
    },
    {
      display: 'Posterior Adult Upper Right',
      returnValue: '17',
    },
    {
      display: 'Posterior Adult Upper Right',
      returnValue: '18',
    },
    {
      display: 'Anterior Adult Upper Left',
      returnValue: '21',
    },
    {
      display: 'Anterior Adult Upper Left',
      returnValue: '22',
    },
    {
      display: 'Anterior Adult Upper Left',
      returnValue: '23',
    },
    {
      display: 'Posterior Adult Upper Left',
      returnValue: '24',
    },
    {
      display: 'Posterior Adult Upper Left',
      returnValue: '25',
    },
    {
      display: 'Posterior Adult Upper Left',
      returnValue: '26',
    },
    {
      display: 'Posterior Adult Upper Left',
      returnValue: '27',
    },
    {
      display: 'Posterior Adult Upper Left',
      returnValue: '28',
    },
    {
      display: 'Anterior Adult Lower Left',
      returnValue: '31',
    },
    {
      display: 'Anterior Adult Lower Left',
      returnValue: '32',
    },
    {
      display: 'Anterior Adult Lower Left',
      returnValue: '33',
    },
    {
      display: 'Posterior Adult Lower Left',
      returnValue: '34',
    },
    {
      display: 'Posterior Adult Lower Left',
      returnValue: '35',
    },
    {
      display: 'Posterior Adult Lower Left',
      returnValue: '36',
    },
    {
      display: 'Posterior Adult Lower Left',
      returnValue: '37',
    },
    {
      display: 'Posterior Adult Lower Left',
      returnValue: '38',
    },
    {
      display: 'Anterior Adult Lower Right',
      returnValue: '41',
    },
    {
      display: 'Anterior Adult Lower Right',
      returnValue: '42',
    },
    {
      display: 'Anterior Adult Lower Right',
      returnValue: '43',
    },
    {
      display: 'Posterior Adult Lower Right',
      returnValue: '44',
    },
    {
      display: 'Posterior Adult Lower Right',
      returnValue: '45',
    },
    {
      display: 'Posterior Adult Lower Right',
      returnValue: '46',
    },
    {
      display: 'Posterior Adult Lower Right',
      returnValue: '47',
    },
    {
      display: 'Posterior Adult Lower Right',
      returnValue: '48',
    },
    {
      display: 'Anterior Baby Upper Right',
      returnValue: '51',
    },
    {
      display: 'Anterior Baby Upper Right',
      returnValue: '52',
    },
    {
      display: 'Anterior Baby Upper Right',
      returnValue: '53',
    },
    {
      display: 'Posterior Baby Upper Right',
      returnValue: '54',
    },
    {
      display: 'Posterior Baby Upper Right',
      returnValue: '55',
    },
    {
      display: 'Anterior Baby Upper Left',
      returnValue: '61',
    },
    {
      display: 'Anterior Baby Upper Left',
      returnValue: '62',
    },
    {
      display: 'Anterior Baby Upper Left',
      returnValue: '63',
    },
    {
      display: 'Posterior Baby Upper Left',
      returnValue: '64',
    },
    {
      display: 'Posterior Baby Upper Left',
      returnValue: '65',
    },
    {
      display: 'Anterior Baby Lower Left',
      returnValue: '71',
    },
    {
      display: 'Anterior Baby Lower Left',
      returnValue: '72',
    },
    {
      display: 'Anterior Baby Lower Left',
      returnValue: '73',
    },
    {
      display: 'Posterior Baby Lower Left',
      returnValue: '74',
    },
    {
      display: 'Posterior Baby Lower Left',
      returnValue: '75',
    },
    {
      display: 'Anterior Baby Lower Right',
      returnValue: '81',
    },
    {
      display: 'Anterior Baby Lower Right',
      returnValue: '82',
    },
    {
      display: 'Anterior Baby Lower Right',
      returnValue: '83',
    },
    {
      display: 'Posterior Baby Lower Right',
      returnValue: '84',
    },
    {
      display: 'Posterior Baby Lower Right',
      returnValue: '85',
    },
  ],
  relatedArticle1: {
    heading: 'Prevention is better than cure when it comes to dental health',
    toUrl: 'https://healthhq.defencehealth.com.au/2021/06/22/prevention-is-better-than-cure-when-it-comes-to-dental-health/',
    imageUrl: 'https://healthhq.defencehealth.com.au/wp-content/uploads/2015/11/Oral-health.jpg',
    imageAltText: 'patient sitting in front of the dentist smiling',
    tag: 'Dental Health',
    listedTime: '2021-06-21T19:58:13',
  },
  relatedArticle2: {
    heading: 'When should I see a podiatrist?',
    toUrl: 'https://healthhq.defencehealth.com.au/2021/04/04/when-should-i-see-a-podiatrist/',
    imageUrl: 'https://healthhq.defencehealth.com.au/wp-content/uploads/2019/08/When-should-I-see-a-podiatrist-1024x682.jpg',
    imageAltText: "doctor measuring patient's foot",
    tag: 'Extras Cover',
    listedTime: '2021-04-04T13:23:44',
  },
  relatedArticle3: {
    heading: 'What’s the difference between a dentist and dental hygienist?',
    toUrl: 'https://healthhq.defencehealth.com.au/2019/01/29/whats-the-difference-between-a-dentist-and-dental-hygienist/',
    imageUrl: 'https://healthhq.defencehealth.com.au/wp-content/uploads/2019/01/Difference-between-dentist-and-dental-hygenist.jpg',
    imageAltText: 'patient and dentist smiling',
    tag: 'Dentist',
    listedTime: '2019-01-29T12:23:43',
  },
};

// Below is for Make a new claim
export const ClaimMultiStepFormReferenceData = {
  claimsInformationText: {
    informationText:
      '<p>Claims can be made for services covered on your Extras product.​</p>\r\n\r\n<p>Keep your receipt handy. It has all the information we need to process your claim - who received the service, what the service was, who provided the service and the fee charged. ​</p>\r\n\r\n<p>You can submit a claim for multiple services from the same provider and patient. To claim for a different patient or service you&rsquo;ll need to start a new claim.</p>\r\n',
  },
  claimsAccountAlertText: {
    informationText:
      '<p>We don&rsquo;t have a claim account recorded, please update your <a href="/portal/$memberNumber$/Member-Selection/Payment-Details" target="_blank">payment information</a> before starting your claim.</p>\r\n',
  },
  claimsAccountAlertTextAlt: {
    informationText: '<p>We do not have a claim account recorded for all members on your policy. Benefits will only be able to be deposited into a bank account on file.</p>\r\n',
  },
  memberReceivingServicesHelpText: {
    informationText: '<p>Your ability to claim for other members on the policy is dependent on your level of authority for the membership.</p>\r\n',
  },
  searchProviderHelpText: {
    informationText: '<p>Search tip: If you know the provider number, this is the quickest way to search.</p>\r\n',
  },
  toothNumberOptions: [
    {
      display: 'Anterior Adult Upper Right',
      returnValue: '11',
    },
    {
      display: 'Anterior Adult Upper Right',
      returnValue: '12',
    },
    {
      display: 'Anterior Adult Upper Right',
      returnValue: '13',
    },
    {
      display: 'Posterior Adult Upper Right',
      returnValue: '14',
    },
    {
      display: 'Posterior Adult Upper Right',
      returnValue: '15',
    },
    {
      display: 'Posterior Adult Upper Right',
      returnValue: '16',
    },
    {
      display: 'Posterior Adult Upper Right',
      returnValue: '17',
    },
    {
      display: 'Posterior Adult Upper Right',
      returnValue: '18',
    },
    {
      display: 'Anterior Adult Upper Left',
      returnValue: '21',
    },
    {
      display: 'Anterior Adult Upper Left',
      returnValue: '22',
    },
    {
      display: 'Anterior Adult Upper Left',
      returnValue: '23',
    },
    {
      display: 'Posterior Adult Upper Left',
      returnValue: '24',
    },
    {
      display: 'Posterior Adult Upper Left',
      returnValue: '25',
    },
    {
      display: 'Posterior Adult Upper Left',
      returnValue: '26',
    },
    {
      display: 'Posterior Adult Upper Left',
      returnValue: '27',
    },
    {
      display: 'Posterior Adult Upper Left',
      returnValue: '28',
    },
    {
      display: 'Anterior Adult Lower Left',
      returnValue: '31',
    },
    {
      display: 'Anterior Adult Lower Left',
      returnValue: '32',
    },
    {
      display: 'Anterior Adult Lower Left',
      returnValue: '33',
    },
    {
      display: 'Posterior Adult Lower Left',
      returnValue: '34',
    },
    {
      display: 'Posterior Adult Lower Left',
      returnValue: '35',
    },
    {
      display: 'Posterior Adult Lower Left',
      returnValue: '36',
    },
    {
      display: 'Posterior Adult Lower Left',
      returnValue: '37',
    },
    {
      display: 'Posterior Adult Lower Left',
      returnValue: '38',
    },
    {
      display: 'Anterior Adult Lower Right',
      returnValue: '41',
    },
    {
      display: 'Anterior Adult Lower Right',
      returnValue: '42',
    },
    {
      display: 'Anterior Adult Lower Right',
      returnValue: '43',
    },
    {
      display: 'Posterior Adult Lower Right',
      returnValue: '44',
    },
    {
      display: 'Posterior Adult Lower Right',
      returnValue: '45',
    },
    {
      display: 'Posterior Adult Lower Right',
      returnValue: '46',
    },
    {
      display: 'Posterior Adult Lower Right',
      returnValue: '47',
    },
    {
      display: 'Posterior Adult Lower Right',
      returnValue: '48',
    },
    {
      display: 'Anterior Baby Upper Right',
      returnValue: '51',
    },
    {
      display: 'Anterior Baby Upper Right',
      returnValue: '52',
    },
    {
      display: 'Anterior Baby Upper Right',
      returnValue: '53',
    },
    {
      display: 'Posterior Baby Upper Right',
      returnValue: '54',
    },
    {
      display: 'Posterior Baby Upper Right',
      returnValue: '55',
    },
    {
      display: 'Anterior Baby Upper Left',
      returnValue: '61',
    },
    {
      display: 'Anterior Baby Upper Left',
      returnValue: '62',
    },
    {
      display: 'Anterior Baby Upper Left',
      returnValue: '63',
    },
    {
      display: 'Posterior Baby Upper Left',
      returnValue: '64',
    },
    {
      display: 'Posterior Baby Upper Left',
      returnValue: '65',
    },
    {
      display: 'Anterior Baby Lower Left',
      returnValue: '71',
    },
    {
      display: 'Anterior Baby Lower Left',
      returnValue: '72',
    },
    {
      display: 'Anterior Baby Lower Left',
      returnValue: '73',
    },
    {
      display: 'Posterior Baby Lower Left',
      returnValue: '74',
    },
    {
      display: 'Posterior Baby Lower Left',
      returnValue: '75',
    },
    {
      display: 'Anterior Baby Lower Right',
      returnValue: '81',
    },
    {
      display: 'Anterior Baby Lower Right',
      returnValue: '82',
    },
    {
      display: 'Anterior Baby Lower Right',
      returnValue: '83',
    },
    {
      display: 'Posterior Baby Lower Right',
      returnValue: '84',
    },
    {
      display: 'Posterior Baby Lower Right',
      returnValue: '85',
    },
  ],
  financialYearBenefitLimitHelpText: {
    informationText:
      '<p>If this claim type is included in your flexi-limits, this limit applies to all inclusions in your flexi-limit.​</p>\r\n\r\n<p><a href="/portal/Support/Help-HQ/2019/November/Extra-flexibility-with-flexi-limits" target="_blank">Check your flexi-limit inclusions.</a></p>\r\n',
  },
  claimSubmissionInformationText: {
    informationText:
      '<p>This claim has been assessed and your benefits payable will be deposited in your nominated account.</p><p>This assessment is based on the information you provided, your current cover, remaining annual benefit and service frequency limits.</p><p>If you need assistance, please <a href="/portal/$memberNumber$/Support/Contact-Us" tabindex="0" target="_blank">get in touch</a>.</p>',
  },
  claimSubmissionKeepPrivateAlertText: {
    informationText: '<p>This member has requested privacy. The result of this claim will only be visible to them.</p>\r\n',
  },
  claimSubmissionKeepPrivateInformationText: {
    informationText:
      '<p>The results of this claim will only be visible to the member who received the services.​</p>\r\n\r\n<p>Individual&nbsp;<a href="/portal/Support/Help-HQ/2019/November/The-importance-of-managing-individual-privacy">privacy</a>&nbsp;is available to for all members aged 16 and over.</p>\r\n',
  },
  relatedArticle1: {
    heading: 'Prevention is better than cure when it comes to dental health',
    toUrl: 'https://healthhq.defencehealth.com.au/2021/06/22/prevention-is-better-than-cure-when-it-comes-to-dental-health/',
    imageUrl: 'https://healthhq.defencehealth.com.au/wp-content/uploads/2015/11/Oral-health.jpg',
    imageAltText: 'patient sitting in front of the dentist smiling',
    tag: 'Dental Health',
    listedTime: '2021-06-21T19:58:13',
  },
  relatedArticle2: {
    heading: 'When should I see a podiatrist?',
    toUrl: 'https://healthhq.defencehealth.com.au/2021/04/04/when-should-i-see-a-podiatrist/',
    imageUrl: 'https://healthhq.defencehealth.com.au/wp-content/uploads/2019/08/When-should-I-see-a-podiatrist-1024x682.jpg',
    imageAltText: "doctor measuring patient's foot",
    tag: 'Extras Cover',
    listedTime: '2021-04-04T13:23:44',
  },
  relatedArticle3: {
    heading: 'What’s the difference between a dentist and dental hygienist?',
    toUrl: 'https://healthhq.defencehealth.com.au/2019/01/29/whats-the-difference-between-a-dentist-and-dental-hygienist/',
    imageUrl: 'https://healthhq.defencehealth.com.au/wp-content/uploads/2019/01/Difference-between-dentist-and-dental-hygenist.jpg',
    imageAltText: 'patient and dentist smiling',
    tag: 'Dentist',
    listedTime: '2019-01-29T12:23:43',
  },
};

export const ClaimProductsAndModalities = {
  claimsAccount: {
    accounts: [
      {
        personCode: '2922',
        firstName: 'Elaine',
        lastName: 'Benes',
        keepPrivate: false,
        claimsAccount: {
          accountId: '1',
          bsb: '121212',
          accountNumber: '2121212',
          accountHolderName: 'Elaine Benes',
        },
      },
      {
        personCode: '2408',
        firstName: 'Elaine2',
        lastName: 'Benes',
        keepPrivate: true,
        claimsAccount: {
          accountId: undefined,
          bsb: '222-222',
          accountNumber: '2222-2222',
          accountHolderName: 'Elaine2 Benes',
        },
      },
      {
        personCode: 'Member-1006',
        firstName: 'Seven',
        lastName: 'Puddy',
        keepPrivate: true,
        claimsAccount: {
          bsb: '333-333',
          accountNumber: '3333-3333',
          accountHolderName: 'David Puddy',
        },
      },
      {
        personCode: '2411',
        firstName: 'Dana',
        lastName: 'Puddy',
        keepPrivate: false,
        claimsAccount: null,
      },
    ],
  },
  claimsMemberModalities: {
    fetchProductType: null,
    memberNumber: '10108246',
    members: [
      {
        personCode: '2922',
        firstName: 'Elaine',
        lastName: 'Benes',
        products: [
          {
            productCode: 'AMBULANCE',
            startDate: '2023-01-01',
          },
          {
            productCode: 'PREMIER_EXTRAS',
            startDate: '2023-01-01',
          },
        ],
      },
      {
        personCode: '2408',
        firstName: 'Elaine2',
        lastName: 'Benes',
        accessLevel: 'Full access',
        products: [
          {
            productCode: 'AMBULANCE',
            startDate: '2023-01-01',
          },
        ],
      },
      {
        personCode: '2409',
        firstName: 'David',
        lastName: 'Puddy',
        products: [
          {
            productCode: 'AMBULANCE',
            startDate: '2023-01-01',
          },
          {
            productCode: 'PREMIER_EXTRAS',
            startDate: '2023-01-01',
          },
        ],
      },
      {
        personCode: 'Member-1006',
        firstName: 'Seven',
        lastName: 'Puddy',
        products: [
          {
            productCode: 'AMBULANCE',
            startDate: '2023-01-01',
          },
          {
            productCode: 'PREMIER_EXTRAS',
            startDate: '2023-01-01',
          },
        ],
      },
    ],
    products: [
      {
        productId: '2073',
        productCode: 'AMBULANCE',
        productType: 'AMBULANCE',
        modalities: [
          {
            modalityId: '2073',
            modalityCode: 'AMBULANCE',
            modalityName: 'Ambulance Modality',
            modatlityEndDate: null,
          },
        ],
        clinicalCategories: null,
      },
      {
        productId: '2067',
        productCode: 'PREMIER_EXTRAS',
        productType: 'EXTRAS',
        modalities: [
          {
            modalityId: '2126',
            modalityCode: 'WIG',
            modalityName: 'Wig Modality',
            modatlityEndDate: null,
          },
          {
            modalityId: '2310',
            modalityCode: 'ORTHO',
            modalityName: 'Orthodontics Modality',
            modatlityEndDate: null,
          },
          {
            modalityId: '2170',
            modalityCode: 'OSTEO',
            modalityName: 'Osteotherapy Modality',
            modatlityEndDate: null,
          },
          {
            modalityId: '2127',
            modalityCode: 'PHARM',
            modalityName: 'Pharmacy Modality',
            modatlityEndDate: null,
          },
          {
            modalityId: '2048',
            modalityCode: 'EPIPEN',
            modalityName: 'EpiPen Modality',
            modatlityEndDate: null,
          },
          {
            modalityId: '2060',
            modalityCode: 'OPTICAL',
            modalityName: 'Optical Modality',
            modatlityEndDate: null,
          },
          {
            modalityId: '2017',
            modalityCode: 'PODIATRY',
            modalityName: 'Podiatry Modality',
            modatlityEndDate: null,
          },
          {
            modalityId: '2147',
            modalityCode: 'AUDIOLOGY',
            modalityName: 'Audiology Modality',
            modatlityEndDate: null,
          },
          {
            modalityId: '2311',
            modalityCode: 'DIETETICS',
            modalityName: 'Dietetics Modality',
            modatlityEndDate: null,
          },
          {
            modalityId: '2201',
            modalityCode: 'HEAR_AIDS',
            modalityName: 'Hearing Aids Modality',
            modatlityEndDate: null,
          },
          {
            modalityId: '2064',
            modalityCode: 'GEN_DENTAL',
            modalityName: 'General and Preventative Dental Modality',
            modatlityEndDate: null,
          },
          {
            modalityId: '2044',
            modalityCode: 'MYOTHERAPY',
            modalityName: 'Myotherapy Modality',
            modatlityEndDate: null,
          },
          {
            modalityId: '2156',
            modalityCode: 'ORTH_SHOES',
            modalityName: 'Orthopaedic Shoes Modality',
            modatlityEndDate: null,
          },
          {
            modalityId: '2066',
            modalityCode: 'PSYCHOLOGY',
            modalityName: 'Psychology Modality',
            modatlityEndDate: null,
          },
          {
            modalityId: '2005',
            modalityCode: 'TRAVEL_VAC',
            modalityName: 'Travel Vaccination Modality',
            modatlityEndDate: null,
          },
          {
            modalityId: '2020',
            modalityCode: 'ACUPUNCTURE',
            modalityName: 'Acupuncture Modality',
            modatlityEndDate: null,
          },
          {
            modalityId: '2022',
            modalityCode: 'EYE_THERAPY',
            modalityName: 'Eye Therapy Modality',
            modatlityEndDate: null,
          },
          {
            modalityId: '2196',
            modalityCode: 'REM_MASSAGE',
            modalityName: 'Remedial Massage Modality',
            modatlityEndDate: null,
          },
          {
            modalityId: '2079',
            modalityCode: 'CHIROPRACTIC',
            modalityName: 'Chiropractic Modality ',
            modatlityEndDate: null,
          },
          {
            modalityId: '2034',
            modalityCode: 'GROUP_PHYSIO',
            modalityName: 'Group Physiotherapy Modality',
            modatlityEndDate: null,
          },
          {
            modalityId: '2059',
            modalityCode: 'MAJOR_DENTAL',
            modalityName: 'Major Dental Modality',
            modatlityEndDate: null,
          },
          {
            modalityId: '2021',
            modalityCode: 'TENS_MACHINE',
            modalityName: 'TENS Machine Modality',
            modatlityEndDate: null,
          },
          {
            modalityId: '2032',
            modalityCode: 'COMP_GARMENTS',
            modalityName: 'Compression Garments Modality',
            modatlityEndDate: null,
          },
          {
            modalityId: '2207',
            modalityCode: 'MOBILITY_AIDS',
            modalityName: 'Mobility Aids Modality',
            modatlityEndDate: null,
          },
          {
            modalityId: '2199',
            modalityCode: 'PHYSIOTHERAPY',
            modalityName: 'Physiotherapy Modality',
            modatlityEndDate: null,
          },
          {
            modalityId: '2136',
            modalityCode: 'ANTE_POSTNATAL',
            modalityName: 'Ante & Postnatal Modality',
            modatlityEndDate: null,
          },
          {
            modalityId: '2146',
            modalityCode: 'ARTIFICIAL_EYE',
            modalityName: 'Artificial Eye Modality',
            modatlityEndDate: null,
          },
          {
            modalityId: '2083',
            modalityCode: 'EXE_PHYSIOLOGY',
            modalityName: 'Exercise Physiology Modality',
            modatlityEndDate: null,
          },
          {
            modalityId: '2184',
            modalityCode: 'FOOT_ORTHOTICS',
            modalityName: 'Foot Orthotics Modality',
            modatlityEndDate: null,
          },
          {
            modalityId: '2052',
            modalityCode: 'NEB_AND_SPACER',
            modalityName: 'Nebuliser and Spacer Modality',
            modatlityEndDate: null,
          },
          {
            modalityId: '2144',
            modalityCode: 'RENTAL_OF_APPS',
            modalityName: 'Rental of Appliances Modality',
            modatlityEndDate: null,
          },
          {
            modalityId: '2191',
            modalityCode: 'SPEECH_THERAPY',
            modalityName: 'Speech Therapy Modality',
            modatlityEndDate: null,
          },
          {
            modalityId: '2187',
            modalityCode: 'APP_MAINTENANCE',
            modalityName: 'Appliance Maintenance Modality',
            modatlityEndDate: null,
          },
          {
            modalityId: '2142',
            modalityCode: 'GROUP_EX_PHYSIO',
            modalityName: 'Group Exercise Physiology Modality',
            modatlityEndDate: null,
          },
          {
            modalityId: '2029',
            modalityCode: 'SCHOOL_ACCIDENTS',
            modalityName: 'School Accidents Modality',
            modatlityEndDate: null,
          },
          {
            modalityId: '2131',
            modalityCode: 'NON_COSMETIC_PROS',
            modalityName: 'Non Cosmetic Prostheses Modality',
            modatlityEndDate: null,
          },
          {
            modalityId: '2101',
            modalityCode: 'BLOOD_GLU_MONITIOR',
            modalityName: 'Blood Glucose Monitor',
            modatlityEndDate: null,
          },
          {
            modalityId: '2174',
            modalityCode: 'SPLINTS_AND_BRACES',
            modalityName: 'Splints and Braces Modality',
            modatlityEndDate: null,
          },
          {
            modalityId: '2038',
            modalityCode: 'TESTS_AND_PROGRAMS',
            modalityName: 'Tests and Programs Modality',
            modatlityEndDate: null,
          },
          {
            modalityId: '2177',
            modalityCode: 'BLOOD_PRES_MONITIOR',
            modalityName: 'Blood Pressure Monitor',
            modatlityEndDate: null,
          },
          {
            modalityId: '2148',
            modalityCode: 'EXTERNAL_BREAST_PROS',
            modalityName: 'External Breast Prostheses Modality',
            modatlityEndDate: null,
          },
          {
            modalityId: '2143',
            modalityCode: 'OCCUPATIONAL_THERAPY',
            modalityName: 'Occupational Therapy Modality',
            modatlityEndDate: null,
          },
          {
            modalityId: '2306',
            modalityCode: 'LASER_REF_EYE_SURGERY',
            modalityName: 'Laser Refractive Eye Surgery Modality',
            modatlityEndDate: null,
          },
          {
            modalityId: '2080',
            modalityCode: 'PAP_MACH_FOR_SLEEP_AP',
            modalityName: 'PAP Machines for Sleep Aponea Modality',
            modatlityEndDate: null,
          },
          {
            modalityId: '2018',
            modalityCode: 'JOINT_FLUID_REP_INJECT',
            modalityName: 'Joint Fluid Replacement Injection Modality',
            modatlityEndDate: null,
          },
          {
            modalityId: '2067',
            modalityCode: 'NON_SIGHT_COR_IRLEN_LENSE',
            modalityName: 'Non-Sight Correcting Irlen Modality',
            modatlityEndDate: null,
          },
        ],
        clinicalCategories: null,
      },
    ],
  },
};

// Common
export const ProvidersForSelectedModality = {
  modalityCode: 'Dental',
  providers: [
    {
      providerId: '0000000A',
      flexCode: 'a',
      firstName: 'Gail',
      middleName: 'Gail',
      lastName: 'Schwartz',
      addressLine1: '8 Exhibition Street',
      addressLine2: 'Apt 1',
      addressLine3: 'Cross street',
      suburb: 'Melbourne',
      state: 'VIC',
      postcode: '3000',
      subProviderIdentifier: '0000000A',
      subProviderIdentifierType: 'ARHG',
    },
    {
      providerId: '0000000A', // sometimes there can be providers returned with same `providerId` but different `subProviderIdentifierType` (eg. type can be HICAPS vs ARHG)
      flexCode: 'a',
      firstName: 'Gail',
      middleName: 'Gail',
      lastName: 'Schwartz',
      addressLine1: '8 Exhibition Street',
      addressLine2: 'Apt 1',
      addressLine3: 'Cross street',
      suburb: 'Melbourne',
      state: 'VIC',
      postcode: '3000',
      subProviderIdentifier: '0000000A',
      subProviderIdentifierType: 'HICAPS',
    },
    {
      providerId: '0000000B',
      flexCode: 'b',
      firstName: 'Sneha',
      middleName: 'Sneha',
      lastName: 'Koshy',
      addressLine1: '200 George St',
      addressLine2: 'Apt 1',
      addressLine3: 'Cross street',
      suburb: 'Sydney',
      state: 'NSW',
      postcode: '2000',
      subProviderIdentifier: '0000000B',
      subProviderIdentifierType: 'ARHG',
    },
    {
      providerId: '0000000C',
      flexCode: 'c',
      firstName: 'Steve',
      middleName: 'Steve',
      lastName: 'Koshy',
      addressLine1: '111 Eagle St',
      addressLine2: 'Apt 1',
      addressLine3: 'Cross street',
      suburb: 'Brisbane',
      state: 'QLD',
      postcode: '4000',
      subProviderIdentifier: '0000000A',
      subProviderIdentifierType: 'ARHG',
    },
    {
      providerId: '0000000D',
      flexCode: 'd',
      firstName: 'Nathan',
      middleName: 'Nathan',
      lastName: 'MacDonald',
      addressLine1: '121 King William St',
      addressLine2: 'Apt 1',
      addressLine3: 'Cross street',
      suburb: 'Adelaide',
      state: 'SA',
      postcode: '5000',
      subProviderIdentifier: '0000000D',
      subProviderIdentifierType: 'ARHG',
    },
    {
      providerId: '0000000E',
      flexCode: 'e',
      firstName: 'Katrina',
      middleName: 'Katrina',
      lastName: 'Huynh',
      addressLine1: '11 Mounts Bay Rd',
      addressLine2: 'Apt 1',
      addressLine3: 'Cross street',
      suburb: 'Perth',
      state: 'WA',
      postcode: '6000',
      subProviderIdentifier: '0000000E',
      subProviderIdentifierType: 'ARHG',
    },
    {
      providerId: '0000000F',
      flexCode: 'f',
      firstName: 'Rachel',
      middleName: 'Rachel',
      lastName: 'Dhawale',
      addressLine1: '121 Marcus Clarke St',
      addressLine2: 'Apt 1',
      addressLine3: 'Cross street',
      suburb: 'Canberra',
      state: 'ACT',
      postcode: '2601',
      subProviderIdentifier: '0000000F',
      subProviderIdentifierType: 'ARHG',
    },
    {
      providerId: '0000000G',
      flexCode: 'g',
      firstName: 'Ben',
      middleName: 'Ben',
      lastName: 'Zhang',
      addressLine1: '11 Mounts Bay Rd',
      addressLine2: 'Apt 1',
      addressLine3: 'Cross street',
      suburb: 'Perth',
      state: 'WA',
      postcode: '6000',
      subProviderIdentifier: '0000000G',
      subProviderIdentifierType: 'ARHG',
    },
    {
      providerId: '0000000H',
      flexCode: 'h',
      firstName: 'Jae',
      middleName: 'Jae',
      lastName: 'Jung',
      addressLine1: '111 Eagle St',
      addressLine2: 'Apt 1',
      addressLine3: 'Cross street',
      suburb: 'Brisbane',
      state: 'QLD',
      postcode: '4000',
      subProviderIdentifier: '0000000H',
      subProviderIdentifierType: 'ARHG',
    },
    {
      providerId: '0000000I',
      flexCode: 'i',
      firstName: 'Le',
      middleName: 'Le',
      lastName: 'Nguyen',
      addressLine1: '121 King William St',
      addressLine2: 'Apt 1',
      addressLine3: 'Cross street',
      suburb: 'Adelaide',
      state: 'SA',
      postcode: '5000',
      subProviderIdentifier: '0000000I',
      subProviderIdentifierType: 'ARHG',
    },
    {
      providerId: '0000000J',
      flexCode: 'j',
      firstName: 'Andrew',
      middleName: 'Andrew',
      lastName: 'Lee',
      addressLine1: '11 Mounts Bay Rd',
      addressLine2: 'Apt 1',
      addressLine3: 'Cross street',
      suburb: 'Perth',
      state: 'WA',
      postcode: '6000',
      subProviderIdentifier: '0000000J',
      subProviderIdentifierType: 'ARHG',
    },
    {
      providerId: '0000000K',
      flexCode: 'k',
      firstName: 'Jeffery',
      middleName: 'Jeffery',
      lastName: 'Qi',
      addressLine1: '121 Marcus Clarke St',
      addressLine2: 'Apt 1',
      addressLine3: 'Cross street',
      suburb: 'Canberra',
      state: 'ACT',
      postcode: '2601',
      subProviderIdentifier: '0000000K',
      subProviderIdentifierType: 'ARHG',
    },
  ],
};

export const ServicesForSelectedModality = {
  services: [
    {
      serviceId: '651',
      flexCode: 'FUND_CODES',
      serviceName: 'Hard coating - single',
      toothIdRequired: true,
    },
    {
      serviceId: '211',
      flexCode: 'FUND_CODES',
      serviceName: 'Single vision stock lens - single',
      toothIdRequired: false,
    },
  ],
};
